import request from '@/config/request'

export default {

    searchUserInfo: function (openId, status) {
        return request({
            url: '/wechat/userinfo/searchuserinfo',
            method: 'get',
            params: {
                openid: openId,
                status: status
            }
        })
    },
    registerUserInfo: function (appKey,openId, mobile, verifyCode,nickName,headImage,sex,status) {
        return request({
            url: '/wechat/userinfo/registeruserinfo',
            method: 'post',
            params: {
                appkey: appKey,
                openid: openId,
                mobile: mobile,
                nickname: nickName,
                verifycode: verifyCode,
                headimage:headImage,
                sex: sex,
                status: status,
            }
        })
    },
    logoutWechat: function (openId, status) {
        return request({
            url: '/wechat/userinfo/logoutwechat',
            method: 'get',
            params: {
                openid: openId,
                status: status
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/wechat/userinfo.js